export type Hjalpmedel = {
    id: number;
    displayName: string;
};

export const convertHjalpmedelData = ({ hjalpmedel }: { hjalpmedel: Hjalpmedel }) => {
    if (!hjalpmedel) {
        return null;
    }

    return {
        value: hjalpmedel.id,
        label: hjalpmedel.displayName,
    };
};
